import { combineReducers } from "@reduxjs/toolkit";
import { themeSlice } from "../slice/theme-slice";
import { fontSlice } from "../slice/theme-slice";

export const rootReducer = combineReducers({
  theme: themeSlice.reducer,
  font: fontSlice.reducer,
});
